module.exports = require("./ff-Adlm-MR.js");